/**
 * Add New Address Route
 */
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import React from 'react';
import Layout from '@/components/Layout';
import AboutUs from '../../../../containers/AboutUs';
import { getSSRStoreData } from '../../../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../../../redux';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const AboutUsPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  return (
    <Layout
      store={storeInfo}
      title={`About us - Now Shop Online`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <AboutUs {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};

  let propData = {
    catalogCategories: [],
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories'],
  });

  propData = { ...propData, ...propType };
  const extraProps = getRequiredCtxProps(ctx, propType);

  return { props: { ...propData, ...extraProps } };
}

export default AboutUsPage;
